import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/user-management";

export const List = async (values) => {
    return await axiosInstance(options).get(`${path}/users/list${objToURL(values)}`);
}

export const Add = async (values) => {
    return await axiosInstance(options).post(`${path}/add`, values);
}

export const Edit = async (values) => {
    return await axiosInstance(options).post(`${path}/edit`, values);
}

export const Delete = async (values) => {
    return await axiosInstance(options).post(`${path}/delete`, values)
}
export const Status = async (values) => {
    return await axiosInstance(options).post(`${path}/delete`, values)
}

export const ExportUser = async (id) => {
    return await axiosInstance(options).get(`${path}/export/${id}`);
}

export const ExportUserPDF = async (id) => {
    return await axiosInstance(options).get(`${path}/export/${id}?format=pdf`, {
        responseType: "blob"
    });
}